import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { OurVision } from './components/OurVision';
import { HowItWorks } from './components/HowItWorks';
import { Benefit } from './components/Benefit';
import { Technology } from './components/Technology';
// import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export const App = () => {
    return (
        <>
            <a href="#main-content" className="skip-link">Skip to main content</a>
            <Header />
            <main id="main-content">
                <Hero />
                <Features />
                <HowItWorks />
                <Benefit />
                <Technology />
                <OurVision />
                {/* <Contact /> */}
            </main>
            <Footer />
        </>
    );
};